import axios from 'axios';
import {Injectable} from "@angular/core";
import {ApiService} from "../services/api.service";

@Injectable({
  providedIn: 'root'
})
export class Vapor{

  constructor(private api: ApiService) {
  }

  acknowledge(key: string, path: string){

    return new Promise(async (resolve) => {

      this.api.apiPost('core/complete-upload', {
        key: key,
        path: path
      }).then(async (res)=>{
        resolve(res);
      });

    });

  }

  store(file: File, options: any = {}) {

    return new Promise(async (resolve) => {

      const data = {
        'content_type': options.contentType || file.type,
        'expires': options.expires || '',
        'visibility': options.visibility || '',
        ...options.data
      };

      this.api.apiPost('core/file-upload', data).then(async (res)=>{

        let headers = res.headers;

        console.log(headers);

        if ('Host' in headers) {
          delete headers['Host'];
          delete headers['X-tenant'];
        }

        if (typeof options.progress === 'undefined') {
          options.progress = () => {};
        }

        const cancelToken = options.cancelToken || ''

        await axios.put(res.url, file, {
          cancelToken: cancelToken,
          headers: headers,
          onUploadProgress: (progressEvent) => {
            options.progress(progressEvent.loaded / progressEvent.total);
          }
        })

        res.extension = file.name.split('.').pop();

        resolve(res);
      });

    });


  }

}
